import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import NavigationsMenu from "./demoside";
import NavigationRouter from "./NavigationRouter";
import AuthService from "../session/AuthService";
import { withTranslation } from "react-i18next";
import i18n from "../i18n";
import { Tooltip } from "@material-ui/core";
import { connect } from "react-redux";
import ChatIndex from "../chatPanel/src/ChatIndex";
import { setUserSelectedFalse } from "../redux/actions/chatActions";
import { getAllChatFriendsList } from "../redux/actions/commonApiActions";
import { MdKeyboardArrowUp } from "react-icons/md";
import Header from "../components/Header/Header";
import PhotoSetUpModel from "../components/PhotoSetUpModel";
import YuukkeAnnouncementModel from "../components/YuukkeAnnouncementModel";
import DynamicFormModel from "../components/DynamicFormModel";
import SubscriptionContainer from "../screens/PremiumBadges/SubscriptionContainer";
import NavPanelOne from "./NavPanelOne";

const EXCLUDED_PATHS = ["photo-set-up", "workspace", "userProfile", "login"];

class Navigations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenu: false,
      prevScrollStatus: false,
      needHelpButtonState: false,
      panel: 1,
      chatDetails: null,
      chatReady: false,
    };
    this.handleMobileMenu = this.handleMobileMenu.bind(this);
  }

  componentDidMount() {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
    this.updateChatDetails();

    // Load friends list when component mounts
    if (this.props.authenticated) {
      this.props.getAllChatFriendsList();
    }
  }

  componentDidUpdate(prevProps) {
    // Load friends list if authentication status changes
    if (!prevProps.authenticated && this.props.authenticated) {
      this.props.getAllChatFriendsList();
    }

    this.updateChatDetails();
  }

  updateChatDetails = () => {
    const { userDetails } = this.props;

    if (
      userDetails &&
      (!this.state.chatDetails ||
        userDetails.uId !== this.state.chatDetails.uId)
    ) {
      this.setState({
        chatDetails: {
          uId: userDetails.uId,
          dName: userDetails.dName,
          profile_uuid: userDetails.profile_uuid,
          timeZone: userDetails.timeZone,
          email: userDetails.email,
          active: userDetails.active,
          uPhoto: userDetails.uPhoto,
        },
      });
    }
  };

  handleMobileMenu = () => {
    this.setState({ mobileMenu: !this.state.mobileMenu });
  };

  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    this.setState({
      prevScrollStatus: currentScrollPos > 360,
    });
  };

  shouldShowChat = () => {
    const { authenticated, accessToken, refreshToken, friendsList } =
      this.props;
    const { chatDetails } = this.state;
    const currentPath = window.location.pathname;

    return (
      authenticated &&
      accessToken !== "" &&
      refreshToken !== "" &&
      Array.isArray(friendsList) &&
      friendsList.length > 0 &&
      chatDetails &&
      !EXCLUDED_PATHS.some((path) => currentPath.includes(path))
    );
  };

  render() {
    const showChat = this.shouldShowChat();
    const chatComponent = showChat && (
      <ChatIndex
        userDetails={this.state.chatDetails}
        authenticated={this.props.authenticated}
        refreshToken={this.props.refreshToken}
        friendsList={this.props.friendsList}
        accessToken={this.props.accessToken}
        selectedUser={this.props.selectedUser}
        closeCallBack={this.props.removeSelectedUser}
      />
    );

    return (
      <Router basename="/">
        {this.props.authenticated &&
        this.state.panel === 1 &&
        !this.props.loginLoader ? (
          <>
            <NavPanelOne />
            {chatComponent}
          </>
        ) : (
          <>
            {!this.props.authenticated && this.props.renderComponent && (
              <Header />
            )}
            <div
              className={
                !this.props.userLoggedIn ? "d-flex flex-column" : "nav-menu-new"
              }
            >
              {this.props.authUser &&
                this.props.authenticated &&
                this.props.refreshToken !== "" &&
                this.props.accessToken != "" &&
                window.location.pathname !== "/photo-set-up" &&
                window.location.pathname !== "/login" && (
                  <nav>
                    <NavigationsMenu
                      needHelpButtonState={this.state.needHelpButtonState}
                    />
                  </nav>
                )}
              <main className="p-relative">
                <NavigationRouter />
              </main>

              {this.props.authUser &&
                this.props.authenticated &&
                this.state.prevScrollStatus && (
                  <span className="up-arrow">
                    <Tooltip title="Scroll to top" placement="top">
                      <div
                        onClick={() =>
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          })
                        }
                      >
                        <MdKeyboardArrowUp
                          style={{
                            color: "white",
                            width: "26px",
                            height: "26px",
                          }}
                        />
                      </div>
                    </Tooltip>
                  </span>
                )}
              {chatComponent}
            </div>
            {/* {!window.location.pathname.includes("photo-set-up") &&
            window.location.pathname !== "/workspace" &&
            this.props.authUser &&
            this.props.authenticated &&
            this.props.refreshToken !== "" &&
            !window.location.pathname.includes("dyNamicFormSluguserProfile") &&
            this.props.accessToken != "" && (
              <div>
                <span className="badge badge-info ask-badge">
                  {this.props.otherRequestCount}
                </span>
                <button className="my-button" onClick={this.gotoNeedHelp}>
                  {t("Ask Help")}
                </button>
              </div>
            )} */}
            {/* </div> */}
            {/* {currentPath.includes("contact-support") ||
          currentPath.includes("error") ? (
          <></>
        ) : (
          "" */}
            {/* <footer>
            <div className="footerWrapper">
            <Grid container spacing={1}>
             <Grid item lg={6} xs={6} sm={6} md={6}>
             <div style={{ marginLeft: "6px", padding: "8px" }}>
                  {" "}
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "12px",
                      marginRight: "5px",
                    }}
                  >
                    © Copyright by yuukke
                  </p>
                </div>
              </Grid>
             <Grid item lg={6} xs={6} sm={6} md={8}>
              <div >
                powered by{" "}
                <a href="https://betamonks.com">               
                   <img  src={logoDark} alt="Header Log" />            
                   </a>
              </div>
                         </Grid>
            </Grid></div>

          </footer> */}
            {/* )} */}{" "}
          </>
        )}
      </Router>
    );
  }
  gotoNeedHelp = () => {
    this.setState({
      needHelpButtonState: !this.state.needHelpButtonState,
    });
  };
}

const mapStateToProps = function (state) {
  return {
    userDetails: state.loginDetailsApi.loginDetails,
    loginLoader: state.loginDetailsApi.loginLoader,
    friendsList: state.commonApi.chatFriendslist, // This is the actual friends list data
    navigationType: state.commonApi.navigationType,
    selectedUser: state.chatList.selectedUser,
    authUser: state.loginDetailsApi.authUser,
    authenticated: state.loginDetailsApi.keycloakAuthenticated,
    accessToken: state.loginDetailsApi.accessToken,
    renderComponent: state.commonApi.renderComponent,
    needToPopUp: state.commonApi.needToPopUp,
    needAnnouncement: state.loginDetailsApi.needAnnouncement,
    userLoggedIn: state.loginDetailsApi.userLoggedIn,
    dynamicFormSlug: state.loginDetailsApi.dynamicFormSlug,
    subscriptionModel: state.event.subscriptionModel,
    refreshToken: state.loginDetailsApi.refreshToken,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    removeSelectedUser: () => dispatch(setUserSelectedFalse()),
    getAllChatFriendsList: () => dispatch(getAllChatFriendsList()), // This is the action dispatcher
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(withTranslation()(Navigations));
